import React, { useContext, useEffect } from 'react';
import useFormProcessor from '../../hooks/useFormProcessor';

import { Context } from '../../providers/global-context.provider';
import { IssuesContext } from '../../providers/issues-context.provider';

import { validateDescription, validateTitle, validatePoints } from '../../utils/validations/issue';
import { getEmptyInputsErrorsObject } from '../../utils/errors/issues';
import { statuses, priorities, types } from '../../data/constants';

import ErrorMessageContainer from '../form-input-error-message';
import IssueFormsInput from '../issue-forms-input';
import CustomLabel from '../label';
import CustomSelect from '../custom-select';

const initialErrors = { Title: '', Description: '', StoryPoints: '' };
const IssueForm = ({ handleFetchData, formTitle, handleModalClose, children, disabled = null }) => {
	const { openedIssue } = useContext(IssuesContext);
	const { data, errors, setErrors, setData, handleChange, handleOnBlur, handleSubmit } = useFormProcessor(
		initialErrors,
		openedIssue
	);
	const { toggleModalIsOpen } = useContext(Context);

	useEffect(
		() => {
			setData(openedIssue);
		},
		[ openedIssue, setData ]
	);

	const getErrors = () => {
		const { Title, Description } = data;
		return getEmptyInputsErrorsObject({ Title, Description });
	};

	const handleFetchAsync = async () => {
		const success = await handleFetchData(data);

		if (success) {
			setErrors({ name: '', key: '' });
			handleModalClose();
			toggleModalIsOpen();
		}
	};

	const getOptions = (options) => {
		return options.map((option, index) => (
			<option key={index} value={index}>
				{option}
			</option>
		));
	};

	return (
		<form
			onSubmit={(e) => handleSubmit(e, getErrors(), handleFetchAsync)}
			className="container px-5 py-2 mx-auto"
			onKeyPress={(e) => {
				e.key === 'Enter' && e.preventDefault();
			}}
		>
			<div className="flex flex-col text-center w-full mb-4">
				<p className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">{formTitle}</p>
			</div>
			<div className="lg:w-2/3 md:w-2/3 mx-auto">
				<div className="flex flex-wrap -m-2">
					<div className="p-2 w-4/6">
						<CustomLabel labelFor="Title">عنوان</CustomLabel>
						<IssueFormsInput
							disabled={disabled}
							handleChange={handleChange}
							handleOnBlur={(event) => handleOnBlur(event, validateTitle, { Title: data.Title })}
							placeholder="عنوان"
							type="text"
							name="Title"
							value={data.Title}
						/>
						{errors.Title ? <ErrorMessageContainer>{errors.Title}</ErrorMessageContainer> : null}
					</div>
					<div className="p-2 w-2/6">
						<CustomLabel labelFor="StoryPoints">مرتبه</CustomLabel>
						<IssueFormsInput
							disabled={disabled}
							handleChange={handleChange}
							handleOnBlur={(event) =>
								handleOnBlur(event, validatePoints, { StoryPoints: data.StoryPoints })}
							placeholder="1, 2, 3, 5, 8, …"
							type="number"
							name="StoryPoints"
							value={data.StoryPoints}
						/>
						{errors.StoryPoints ? (
							<ErrorMessageContainer>{errors.StoryPoints}</ErrorMessageContainer>
						) : null}
					</div>
					<div className="p-2 w-full">
						<textarea
							disabled={disabled}
							onChange={handleChange}
							onBlur={(event) =>
								handleOnBlur(event, validateDescription, { Description: data.Description })}
							name="Description"
							className="w-full bg-gray-100 rounded border border-gray-400 focus:outline-none h-24 focus:border-teal-500 text-base px-4 py-2 resize-none block"
							placeholder="توضیحات کامل"
							value={data.Description}
						/>
						{errors.Description ? (
							<ErrorMessageContainer>{errors.Description}</ErrorMessageContainer>
						) : null}
					</div>
					<div className="p-2 w-full">
						<div className="flex flex-wrap -mx-3 mb-2">
							<CustomSelect
								disabled={disabled}
								label={<CustomLabel>نوع</CustomLabel>}
								value={data.Type}
								name="Type"
								handleChange={handleChange}
							>
								{getOptions(types)}
							</CustomSelect>
							<CustomSelect
								disabled={disabled}
								label={<CustomLabel>اولیت</CustomLabel>}
								value={data.Priority}
								name="Priority"
								handleChange={handleChange}
							>
								{getOptions(priorities)}
							</CustomSelect>
							<CustomSelect
								disabled={disabled}
								label={<CustomLabel>وضعیت</CustomLabel>}
								value={data.Status}
								name="Status"
								handleChange={handleChange}
							>
								{getOptions(statuses)}
							</CustomSelect>
						</div>
					</div>
					<div className="p-2 w-full">{children}</div>
				</div>
			</div>
		</form>
	);
};

export default IssueForm;
